import { api } from "@/lib/api";

const FREE_SESSIONS = new Set(["respiration-5", "present-5", "nuit-20", "sport-5"]);
const FREE_AMBIENTS = new Set(["pink"]);
const FREE_BABY = new Set(["pink"]);

export function isFreeSession(id) { return FREE_SESSIONS.has(id); }
export function isFreeAmbient(id) { return FREE_AMBIENTS.has(id); }
export function isFreeBaby(id) { return FREE_BABY.has(id); }

/** Vérifie côté serveur si l'utilisateur peut lire cet élément.
 *  Retourne { allowed: boolean, reason: string }. */
export async function checkAccess(kind, itemId) {
  try {
    const { data } = await api.get(`/catalog/can-play/${kind}/${encodeURIComponent(itemId)}`);
    return data;
  } catch {
    // En cas d'échec réseau, ne pas contourner la protection
    return { allowed: false, reason: "network_error" };
  }
}
